import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { selectPaymentServiceConf } from '../../../store/selectors/paymentsSelectors';
import { executeTaggeo } from '../../../store/actions';
import { 
    OPEN_NEW_MICROAPP, 
    REDIRECT, 
    OFFER_TELCEL_PAQUETE_POR_TIEMPO, 
    OFFER_TELCEL_PAQUETE_INTERNET_AMIGO, 
    OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL,
    OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN,
    OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO,
    OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO,
    BROWSE,
    NAVIGATE
} from '../../../constants';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import { getTypeOfferValue, getTypeEventValue, getPaymentFlowForTaggeo  } from '../utils';
import { validateUserAgent } from '../utils';

import { isAnonimousSelector } from '../../../store/selectors/paymentsSelectors';
import CarouselMegasTelcel from '../CarouselMegasTelcel';
import PospagoSectionPay from '../../molecules/OfferTelcel/pospagoSectionPay';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
const containerPaddingStyle = validateUserAgent() === "android" ? "0% 0% 10% 0%" : "0% 0% 30% 0%";
const Container = styled.div`
  width: 100%;
  background: ${props => props.background ? props.background : "#f6f6f6"};
  padding: ${containerPaddingStyle}
`;

const CardOfferTelcel = styled.img`
    width: 26%;
    background: #fff;
    margin: ${props => props.index === 0 || props.index == 3 ? "5% 0% 0% 5%" : "5% 0% 0% 5%"};
    box-shadow: 0px 7px 5px -1px rgb(0,0,0,0.2);
    display: inline-block;
    padding: 0%;
    border-radius: 2%;
    height: 90px;
`;

const SubTitle = styled.p`
    font-size: 14px;
    font-family: ${props => props.fontFamily ? props.fontFamily : "Amx-Regular"};
    color: ${props => props.color ? props.color : "#525252"};
    text-align: ${props => props.subtitleAlign ? props.subtitleAlign : "center"};
    margin: ${props => props.subtitleMargin ? props.subtitleMargin : "5% 0% 2% 0%"};
`;

class OfferTelcelWithoutLine extends Component {
    constructor(props) {
        super(props);
        const {userInfo} = this.props
        this.state = {
            isUserTelcel: userInfo && userInfo.isTelcel === "true" || userInfo && userInfo.isTelcel === true ? true:false ,
        }
    }

    componentDidMount() { 
        const { paymentsConfig, executeTaggeo, lineTelcelInformation, planType} = this.props
        const {isUserTelcel} = this.state
        
        if(!isUserTelcel || (isUserTelcel && !lineTelcelInformation) ){
            executeTaggeo({
                action: "View",
                service : paymentsConfig.tagServiceId,
                plan_type : planType,
                step: "Pantalla principal",
                eventName: "telcel"
            })
        }
    }
    
    sendTaggeo = (e, action, typeOffer, typeEvent, microAppId, externalLink ) => {
        e.preventDefault()
        const { paymentsConfig, executeTaggeo, planType, history, paramsNewOfferTelcel, step, event, paymentMethods, isContainerTelcel } = this.props
        const { 
            sdkClaroVersion, 
            isClaroPartner,
            tagServiceId
        } = paymentsConfig

        let params = {
            action: action,
            service : paymentsConfig.tagServiceId,
            plan_type : planType,
            step: step ? step :"Pantalla principal",
            eventName: event ? event : "telcel"
        }

        if (isContainerTelcel) {
            const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
            const flow = getPaymentFlowForTaggeo(
                this.props.isAnonimous, 
                msisdn, 
                this.props.paymentMethods
            );

            params = { ...params, flow };

            if (this.props.quitPlanType) {
                delete params.plan_type
            }
        }

        if (action) {
            executeTaggeo(params)
        }
        const typeEventValue = getTypeEventValue(typeEvent)

        if(typeEventValue === REDIRECT){
            const typeOfferIndex =  getTypeOfferValue(typeOffer)
            console.log(typeOfferIndex, 'aquiiii-typeOfferIndex')
            const pathNameValue = typeOfferIndex == OFFER_TELCEL_PAQUETE_INTERNET_AMIGO ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POR_TIEMPO ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN || 
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO ? 
                (window.location.pathname === "/telcel-plans"?
                    "/telcel-plans/"+ typeOfferIndex:'/telcel-plans'
                )
                :
                '/menuTelcel'
            setTimeout(() => {
                    history.push({
                    pathname: pathNameValue,
                    state: {
                        sdkVersion: sdkClaroVersion,
                        paymentsConfig: paymentsConfig, 
                        isClaroPartner: isClaroPartner,
                        serviceConfigIndex: typeOfferIndex,
                        tagServiceId: tagServiceId,
                        paramsNewOfferTelcel: paramsNewOfferTelcel,
                        isContainerTelcel: this.props.isContainerTelcel
                    }
                })
            }, 500);
        } 
        if(typeEventValue === OPEN_NEW_MICROAPP ){
            const url = {
                app: "startEventNoClose",
                to : "openMicroApp",
                parameters: JSON.stringify({microAppId: microAppId}),
            };
            setTimeout(() => {
                sdkclaro.getInstance().openNative(
                    JSON.stringify(url),
                    () => {},
                    () => {},
                );
            }, 1000);
        }
        if (typeEventValue === BROWSE) {
            ClaroSDKService.openExternalLinks(externalLink)
        }
        if (typeEventValue === NAVIGATE) {
            window.location.replace(externalLink)
        }
    }

    render() {
        let {
            offerTelcel, subtitleAlign, subtitleMargin, 
            paymentsConfig:{mainLogo}, logoIsVisible , subtitle,
            isContainerTelcel, isClaroPartner, lineTelcelInformation, logoMarginTop, showBanner,
            paymentMethods, history
        } = this.props

        offerTelcel = offerTelcel && isContainerTelcel 
            ? offerTelcel.sort((a,b) => a.orderContainer - b.orderContainer) 
            : offerTelcel;

        const showLogo = isContainerTelcel &&
            this.props.amountTelcelPospago &&
            this.props.amountTelcelPospago.pendingAmount &&
            this.props.showButtonPay
                ? "none"
                : logoIsVisible;

        offerTelcel = isContainerTelcel 
            ? offerTelcel
            : offerTelcel.filter(e => !e.onlyContainerTelcel);

        return (
            <Container background={isContainerTelcel && !isClaroPartner ? "#f6f6f6" : undefined}>
                <div style={{textAlign:"center", display:showLogo, paddingTop: logoMarginTop ? logoMarginTop : "0px"}} >
                    <img src={mainLogo.base64} alt="Logo" width={"20%"} />
                </div>
                {
                    isContainerTelcel &&
                    this.props.showButtonPay &&
                    this.props.paymentMethods &&
                    !this.props.isLoadingPaymentMethods &&
                    <PospagoSectionPay history={history} />
                }
                {
                    isContainerTelcel && 
                    showBanner && 
                    paymentMethods 
                        ? 
                            <CarouselMegasTelcel 
                                origin="MiTelcel" 
                                margin="12px 6% 0px 6%" 
                                handleInputClick={() => false} /> 
                        : 
                            <></>
                }
                <SubTitle 
                    subtitleAlign={subtitleAlign}
                    subtitleMargin={subtitleMargin}
                    fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                    color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}
                >
                    {subtitle}
                </SubTitle>
                <div>
                {
                    offerTelcel ? offerTelcel.map(
                        (offer, index) => {
                            return <CardOfferTelcel 
                                key={index}
                                index={index} 
                                onClick={
                                    (e) => this.sendTaggeo(
                                        e, 
                                        offer.taggeoAction, 
                                        offer.typeOffer, 
                                        offer.typeEvent,
                                        offer.microAppId,
                                        offer.externalLink
                                    )
                                }
                                src={offer.image}
                            />;
                        }
                    ) : <SubTitle 
                            fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}  
                            color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}>
                            {"No disponible"}
                        </SubTitle>
                }
                </div>
            </Container>
        )
    }
}

function mapStateToProps(state) {
    const { payments } = state;
    const paymentsConfig = selectPaymentServiceConf(payments);
    const {
        lineTelcelInformation, 
        paymentMethods, 
        isLoadingPaymentMethods,
        isloadingGetAmountTelcelPospago,
        amountTelcelPospago
    } = payments;
    return {
        paymentsConfig,
        userInfo : payments.userInfo,
        lineTelcelInformation,
        paymentMethods,
        isAnonimous: isAnonimousSelector(state),
        isLoadingPaymentMethods,
        isloadingGetAmountTelcelPospago,
        amountTelcelPospago
    };
 
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        executeTaggeo,
    },
    dispatch,
  );
}

OfferTelcelWithoutLine = connect(
  mapStateToProps,
  mapDispatchToProps
)(OfferTelcelWithoutLine);

export default OfferTelcelWithoutLine